import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { isElementInViewport, isElementInParentBlock, getValidParent } from '../../utils';
import { EPercentVisible } from '../../constants/percentVisible';
var THROTTLE_TIME = 100;
var DEFAULT_TIMEOUT = 0;
export function ActionAfterViewed(_ref) {
  var children = _ref.children,
      _ref$percentVisible = _ref.percentVisible,
      percentVisible = _ref$percentVisible === void 0 ? EPercentVisible.Percent50 : _ref$percentVisible,
      _ref$timeoutCallback = _ref.timeoutCallback,
      timeoutCallback = _ref$timeoutCallback === void 0 ? DEFAULT_TIMEOUT : _ref$timeoutCallback,
      parentBlockCssClass = _ref.parentBlockCssClass,
      callback = _ref.callback;
  var timer;
  var parent = {};
  var ref = React.useRef(null); // eslint-disable-next-line react-hooks/exhaustive-deps

  var handleScroll = React.useCallback(throttle(THROTTLE_TIME, function () {
    /* istanbul ignore else */
    if (ref.current) {
      var isVisible = parentBlockCssClass ? isElementInParentBlock(ref.current, parent.current, percentVisible) : isElementInViewport(ref.current, percentVisible);

      if (isVisible) {
        if (!timer) {
          timer = window.setTimeout(function () {
            parent.current.removeEventListener('scroll', handleScroll);
            clearTimeout(timer);
            callback();
          }, timeoutCallback);
        }
      } else if (timer) {
        clearTimeout(timer);
        timer = undefined;
      }
    }
  }), []);
  React.useEffect(function () {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    parent.current = getValidParent(ref.current, parentBlockCssClass);
    parent.current.addEventListener('scroll', handleScroll);
    return function () {
      parent.current.removeEventListener('scroll', handleScroll);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children);
}